import { axiosInstance } from "../../../../Services";
import { PROJECT_BY_CODE_PATH, USE_MOCK } from "./config";
import { mockGetProjectByCode } from "../mock/mockApi";

// Looks up an existing MMH project by its Project Code so Dimensions &
// Structure can be auto-filled instead of typed by hand.
// GET /internal/pm/:projectCode  →  { project: {...} }
export const GetProjectDataByCode = async (projectCode) => {
  if (USE_MOCK) {
    return mockGetProjectByCode(projectCode);
  }
  return axiosInstance.get(`${PROJECT_BY_CODE_PATH}/${projectCode}`);
};

export default GetProjectDataByCode;
